export const loginTypes = [
    'SCAN_BARCODE',
    'APP2APP_OPENINAPP',
    'APP2APP_OPENINSP',
    'PROXIMITY',
    'MANUAL',
    'REMOTE',
    'AUTO_LOGIN',
    'SINGLE_SIGN_ON',
    'PUSH_LOGIN',
    'U2F_LOGIN',
    'NO_OTP_LOGIN',
];

export const loginTypeLabel = loginType => ({
    APP2APP_OPENINAPP: 'sp-login-type.app2app-open-in-app',
    APP2APP_OPENINSP: 'sp-login-type.app2app-open-in-sp',
    AUTO_LOGIN: 'sp-login-type.auto-login',
    MANUAL: 'sp-login-type.manual',
    NO_OTP_LOGIN: 'sp-login-type.no-otp-login',
    PROXIMITY: 'sp-login-type.proximity',
    PUSH_LOGIN: 'sp-login-type.push-login',
    REMOTE: 'sp-login-type.remote',
    SCAN_BARCODE: 'sp-login-type.scan-barcode',
    SINGLE_SIGN_ON: 'sp-login-type.single-sign-on',
    U2F_LOGIN: 'sp-login-type.u2f-login',
})[loginType];



// WEBPACK FOOTER //
// ./src/portal/components/sp-login-type/sp-login-type.enum.js